import { EVSE_AP_INITIAL_CONNECT_DELAY_MS, EVSE_AP_RECONNECT_INTERVAL_MS } from '../constants';

const INITIAL_CONNECT_DELAY_STORAGE_KEY = 'evseApInitialConnectDelaySeconds';
const RECONNECT_INTERVAL_STORAGE_KEY = 'evseApReconnectIntervalSeconds';

const MILLISECONDS_PER_SECOND = 1_000;

export type EvseApReadinessSettings = {
  initialConnectDelaySeconds: number;
  reconnectIntervalSeconds: number;
};

function readSeconds(storageKey: string, defaultMilliseconds: number) {
  const storedValue = localStorage.getItem(storageKey);
  if (storedValue === null) return defaultMilliseconds / MILLISECONDS_PER_SECOND;

  const value = Number(storedValue);
  return Number.isInteger(value) && value >= 0 ? value : defaultMilliseconds / MILLISECONDS_PER_SECOND;
}

export function getEvseApReadinessSettings(): EvseApReadinessSettings {
  return {
    initialConnectDelaySeconds: readSeconds(INITIAL_CONNECT_DELAY_STORAGE_KEY, EVSE_AP_INITIAL_CONNECT_DELAY_MS),
    reconnectIntervalSeconds: readSeconds(RECONNECT_INTERVAL_STORAGE_KEY, EVSE_AP_RECONNECT_INTERVAL_MS),
  };
}

export function saveEvseApReadinessSettings({
  initialConnectDelaySeconds,
  reconnectIntervalSeconds,
}: EvseApReadinessSettings) {
  localStorage.setItem(INITIAL_CONNECT_DELAY_STORAGE_KEY, String(initialConnectDelaySeconds));
  localStorage.setItem(RECONNECT_INTERVAL_STORAGE_KEY, String(reconnectIntervalSeconds));
}

export function getEvseApReadinessTimingMs() {
  const { initialConnectDelaySeconds, reconnectIntervalSeconds } = getEvseApReadinessSettings();
  return {
    initialConnectDelayMs: initialConnectDelaySeconds * MILLISECONDS_PER_SECOND,
    reconnectIntervalMs: reconnectIntervalSeconds * MILLISECONDS_PER_SECOND,
  };
}
